export enum OfferListPaths {
  OFFER_LIST = 'offer-list',
  SHARED_LIST = 'shared-list',
  IN_SERVICE_LIST = 'inservice-list',
  CUSTOM_OFFERS = 'custom-offers',
  OFFER_LIST_UUID = ':offerListUuid'
}
